<ng-container [ngSwitch]="step">
  <db-clone-installation
    *ngSwitchCase="'cloneConfigs'"
    [user]="user"
    [configHostname]="configHostname"
    [websiteIds]="websiteIds"
    [hostedWebsitesCount]="hostedWebsitesCount"
    [hostedWebsitesLimit]="hostedWebsitesLimit"
    [originalDomain]="originalDomain"
    [userSubscription]="userSubscription"
    (onResize)="resize($event)"
    (onStepChange)="changeStep($event)"></db-clone-installation>

<!--  <db-migration-progress
    *ngSwitchCase="'cloneProcess'"
    (resized)="resize([600, $event])"
    (succeed)="showCreateWebsiteSuccessComponent($event.websiteId)"
    (failed)="showManualMigrationModal()"></db-migration-progress>-->

<db-clone-progress
  *ngSwitchCase="'cloneProcess'"
  [websiteUrl]="cloneWebsiteUrl"
  [dataCenter]="dataCenter"
  (failed)="showManualMigrationModal()"></db-clone-progress>
</ng-container>

